import React from 'react';

const SvgEmail = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5 5c-.88 0-1.992 1.106-1.992 2L3 16.06C3 16.953 4.12 18 5 18h13c.88 0 2-1.047 2-1.94V7c0-.894-1.12-2-2-2H5zm6.5 8L5 8.714V7l6.5 4.286L18 7v1.714L11.5 13z",
  fillRule: "evenodd"
}));

export default SvgEmail;